import { z } from 'zod';
import { uploadTypeSchema, uploadTypeSchemaKeys, } from '../index.js';
export const storageApiRoutes = {
    'file/upload-start': {
        path: '/storage/upload/start',
        method: 'POST',
        input: z.object({
            uploadType: uploadTypeSchema,
            file: z.object({
                clientName: z.string(),
                headers: z.object({ 'content-type': z.string().nullable() }),
                size: z.number(),
                meta: z.unknown().optional(),
            }),
        }),
        output: {},
    },
    'file/upload-chunk': {
        path: '/storage/upload/chunk',
        method: 'POST',
        input: z.object({
            sessionId: z.string(),
            key: z.string(),
            partNumber: z.number(),
            partData: z.unknown(),
            totalParts: z.number(),
        }),
        output: {},
    },
    'file/upload-complete': {
        path: '/storage/upload/complete',
        method: 'POST',
        input: z.object({
            sessionId: z.string(),
            key: z.string(),
            parts: z.array(z.object({
                ETag: z.string(),
                PartNumber: z.number(),
            })),
        }),
        output: {},
    },
    'file-relation/duplicate': {
        method: 'POST',
        path: '/storage/:fileRelationId/duplicate',
        input: z.object({
            type: uploadTypeSchemaKeys.optional(),
            blockClientKey: z.string().optional(),
            taskId: z.string().optional(),
            projectId: z.string().optional(),
            organizationId: z.string().optional(),
            taskRequestId: z.string().optional(),
            taskTemplateId: z.string().optional(),
            projectTemplateId: z.string().optional(),
        }),
        output: {},
    },
    'file-relation/delete': {
        method: 'DELETE',
        path: '/storage/:fileRelationId',
        output: {},
    },
    'file-relation/delete-bulk': {
        method: 'POST',
        path: '/storage/delete-bulk',
        input: z.object({
            fileRelationIds: z.array(z.string()),
        }),
        output: {},
    },
    'file/delete': {
        path: '/storage/:key',
        method: 'DELETE',
        output: {},
    },
};
//# sourceMappingURL=storage-api-routes.js.map